<h1 mat-dialog-title>{{'protocolEdit.definitions.title' | translate}}</h1>

<div mat-dialog-content [class]="getTheme()">

  <div fxLayout="column" fxLayout.xs="column" class="flexwrap">
    <div fxFlex="100">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.definitions.term.label' | translate }}</mat-label>
        <input matInput [(ngModel)]="data.definition.term" required [disabled]="data.disabled"
          [ngModelOptions]="{standalone: true}">
        <mat-error>
          {{ 'protocolEdit.definitions.form.error.term' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div fxFlex="100">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.definitions.definition.label' | translate }}</mat-label>
        <input matInput [(ngModel)]="data.definition.definition" [disabled]="data.disabled" [ngModelOptions]="{standalone: true}">
      </mat-form-field>
    </div>
  </div>

</div>

<div mat-dialog-actions align="end" [class]="getTheme()">
  @if (!data.disabled) {
    <button mat-raised-button color="primary" (click)="onOkClick()">
    {{ 'button.save' | translate }}</button>
  }
  <button mat-raised-button color="secondary" (click)="onNoClick()">
  {{ 'button.cancel' | translate }}</button>
</div>